import { OptionData } from "components/DesignSystem/Combobox/Combobox";
import { PREVIOUS_TAX_YEARS_LOOKBACK } from "components/AdvanceTaxAndProfits/constants";

export const getTaxYearOptions = (
  currentYear: number,
  lookback: number = PREVIOUS_TAX_YEARS_LOOKBACK
): OptionData[] => {
  if (!Number.isInteger(currentYear) || currentYear <= 0) return [];

  return Array.from({ length: lookback }, (_, index) => {
    const year = currentYear - (index + 1);
    return { value: String(year), label: String(year) };
  });
};
